import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function TaxCategoryBasicComponent ({handleInnerFormChange,chosenTaxCategory}: any) {
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
            label="Tax name"
            labelField="Tax name"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'TaxName'
              );
            }}
            type="text"
            value={chosenTaxCategory?.TaxName}
        />
     <InputContainer
            label="Tax Percentage"
            labelField="Tax Percentage"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'TaxPercentage'
              );
            }}
            type="number"
            value={chosenTaxCategory?.TaxPercentage}
        />
     <InputContainer
            label="Tax Clasification Name"
            labelField="Tax Clasification Name"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'TaxClasificationName'
              );
            }}
            type="text"
            value={chosenTaxCategory?.TaxClasificationName}
        />
      <InputContainer
            label="Tally Ledger Name"
            labelField="Tally Ledger Name"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'TallyLedgerName'
              );
            }}
            type="text"
            value={chosenTaxCategory?.TallyLedgerName}
        />
      <InputContainer
            label="Tax Type"
            labelField="Tax Type"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'TaxType'
              );
            }}
            type="text"
            value={chosenTaxCategory?.TaxType}
        />
     <InputContainer
            label="Remarks"
            labelField="Remarks"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'Remarks'
              );
            }}
            type="text"
            value={chosenTaxCategory?.Remarks}
        />
      <InputContainer
            label="Active"
            labelField="IsActive"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event,
                'IsActive'
              );
            }}
            type="checkbox"
            value={chosenTaxCategory?.IsActive}
        />
     </div>
  }
    expandedPanel="BasicInfo"
    headerTitle="Tax Category Information"
/>
        </>
  )
}